exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-name-cell .can-download[data-v-71c512dd] {\n  cursor: pointer;\n  user-select: none;\n}\n.file-name-cell .file-name[data-v-71c512dd] {\n  display: inline-block;\n  margin-right: 0.052083rem;\n}\n.file-name-cell .can-download[data-v-71c512dd]:hover {\n  color: rgb(120, 120, 195);\n  text-decoration: underline;\n}\n[data-v-71c512dd] .kp-update-row {\n  background: #0091da;\n  color: #FFFFFF;\n}\n[data-v-71c512dd] .el-table tr:hover {\n  color: #636363;\n}\n.delete[data-v-71c512dd] {\n  color: #fd349c;\n  cursor: pointer;\n}\n.el-icon-download[data-v-71c512dd] {\n  color: #3879EB;\n}", ""]);

// exports
